import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/shared/ui/card";
import BaseLayout from '@/shared/components/accounts/AccountBase';
import { SignupForm } from '@features/signup';
import { useUser } from '@/shared/hooks/useUser';
import { LogoLoading } from '@/shared/ui/custom/logo-loading';

const SignupPage = () => {
  const navigate = useNavigate();
  const { user, loading } = useUser();

  // Redirect authenticated users to dashboard
  useEffect(() => {
    if (!loading && user) {
      navigate('/app', { replace: true });
    }
  }, [user, loading, navigate]);

  // Show loading while checking authentication
  if (loading) {
    return (
      <BaseLayout>
        <div className="flex items-center justify-center min-h-[400px]">
          <LogoLoading 
            variant="breathing" 
            size="xl" 
            message="Checking authentication..." 
          />
        </div>
      </BaseLayout>
    );
  }

  return (
    <BaseLayout>
      <Card className="w-full max-w-md mx-auto">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl text-center">Sign up</CardTitle>
        </CardHeader>
        <CardContent>
          <SignupForm />
        </CardContent>
        <CardFooter className="flex flex-col space-y-4">
          <div className="text-sm text-center">
            Already have an account?{' '}
            <a href="/login" className="text-primary-500 hover:text-primary-600">
              Log in
            </a>
          </div>
        </CardFooter>
      </Card>
    </BaseLayout>
  );
};

export default SignupPage;
